/**
 * Funcionalidades do header
 */

document.addEventListener('DOMContentLoaded', function() {
    // Dropdown de redes sociais
    const socialDropdownButton = document.querySelector('.social-dropdown-button');
    const socialDropdownMenu = document.querySelector('.social-dropdown-menu');
    
    if (socialDropdownButton && socialDropdownMenu) {
        // Função para mostrar/esconder o dropdown
        function toggleSocialDropdown() {
            socialDropdownMenu.classList.toggle('hidden');
        }
        
        // Evento de clique no botão
        socialDropdownButton.addEventListener('click', function(e) {
            e.preventDefault();
            toggleSocialDropdown();
        });
        
        // Fechar dropdown quando clicar fora dele
        document.addEventListener('click', function(e) {
            if (!socialDropdownButton.contains(e.target) && !socialDropdownMenu.contains(e.target)) {
                socialDropdownMenu.classList.add('hidden');
            }
        });
    }

    // Dropdown de whatsapp
    const whatsappDropdownButton = document.querySelector('.whatsapp-dropdown-button');
    const whatsappDropdownMenu = document.querySelector('.whatsapp-dropdown-menu');
    
    if (whatsappDropdownButton && whatsappDropdownMenu) {
        // Função para mostrar/esconder o dropdown
        function toggleWhatsappDropdown() {
            whatsappDropdownMenu.classList.toggle('hidden');
        }
        
        // Evento de clique no botão
        whatsappDropdownButton.addEventListener('click', function(e) {
            e.preventDefault();
            toggleWhatsappDropdown();
        });
        
        // Fechar dropdown quando clicar fora dele
        document.addEventListener('click', function(e) {
            if (!whatsappDropdownButton.contains(e.target) && !whatsappDropdownMenu.contains(e.target)) {
                whatsappDropdownMenu.classList.add('hidden');
            }
        });
    }

    // Fixa o masthead e a top-bar após passar a barra superior
    var masthead = document.getElementById('masthead');
    var spacer = document.querySelector('.js-masthead-spacer');
    var topBar = document.querySelector('.top-bar');
    var logoHeaderDesktop = document.getElementById('logo-header-desktop');

    function applySticky() {
        var topbarHeight = topBar ? topBar.offsetHeight : 0; // ~46px
        var mastheadHeight = masthead ? masthead.offsetHeight : 0; // 64px

        if (window.scrollY > topbarHeight) {
            // Fixar top-bar no topo
            if (topBar) {
                topBar.classList.add('fixed','top-0','left-0','right-0','w-full','z-[1100]');
            }
            // Logo header desktop
            if (logoHeaderDesktop) {
                logoHeaderDesktop.classList.remove('top-[5px]');
                logoHeaderDesktop.classList.add('top-[-40px]');
            }
            // Fixar masthead logo abaixo da top-bar
            if (masthead) {
                masthead.classList.add('fixed','left-0','right-0','w-full','z-[1200]');
                masthead.style.top = topbarHeight + 'px';
            }
            // Spacer = topbar + masthead para não sobrepor conteúdo
            if (spacer) {
                spacer.classList.remove('hidden');
                spacer.style.height = (topbarHeight + mastheadHeight) + 'px';
            }

            // Marcar body como sticky e expor offset para CSS
            document.body.classList.add('is-sticky');
            document.documentElement.style.setProperty('--header-offset', (topbarHeight + mastheadHeight) + 'px');
        } else {
            // Remover estados fixos
            if (topBar) {
                topBar.classList.remove('fixed','top-0','left-0','right-0','w-full','z-[1100]');
            }
            // Logo header desktop
            if (logoHeaderDesktop) {
                logoHeaderDesktop.classList.remove('top-[-40px]');
                logoHeaderDesktop.classList.add('top-[5px]');
            }
            if (masthead) {
                masthead.classList.remove('fixed','left-0','right-0','w-full','z-[1200]');
                masthead.style.top = '';
            }
            if (spacer) {
                spacer.classList.add('hidden');
                spacer.style.height = '';
            }
            // Remover marcação sticky e offset
            document.body.classList.remove('is-sticky');
            document.documentElement.style.removeProperty('--header-offset');
        }
    }

    applySticky();
    window.addEventListener('scroll', applySticky, { passive: true });
    window.addEventListener('resize', applySticky);

    // Posicionar mega menú cuando header está fijo y controlar salida suave
    var menuItems = document.querySelectorAll('#site-navigation .menu-item');
    menuItems.forEach(function(item){
        var mega = item.querySelector('.mega-menu');
        if (!mega) return;

        function clearHideTimer(){
            if (mega.__hideTimer) {
                clearTimeout(mega.__hideTimer);
                mega.__hideTimer = null;
            }
        }

        function showFixedMega(){
            var topbarHeight = topBar ? topBar.offsetHeight : 0;
            var mastheadHeight = masthead ? masthead.offsetHeight : 0;
            mega.style.position = 'fixed';
            mega.style.left = '0';
            mega.style.right = '0';
            mega.style.top = (topbarHeight + mastheadHeight) + 'px';
            mega.style.zIndex = 1300;
            mega.style.pointerEvents = 'auto';
            mega.classList.remove('hidden','opacity-0','invisible');
            mega.classList.add('opacity-100','visible');
        }

        function hideFixedMega(){
            // Ocultar suavemente y luego aplicar hidden para evitar artefactos
            mega.classList.remove('opacity-100','visible');
            mega.classList.add('opacity-0','invisible');
            mega.style.pointerEvents = 'none';
            mega.__hideTimer = setTimeout(function(){
                mega.classList.add('hidden');
                mega.style.position = '';
                mega.style.left = '';
                mega.style.right = '';
                mega.style.top = '';
                mega.style.zIndex = '';
                mega.style.pointerEvents = '';
            }, 120);
        }

        item.addEventListener('mouseenter', function(){
            var topbarHeight = topBar ? topBar.offsetHeight : 0;
            var mastheadHeight = masthead ? masthead.offsetHeight : 0;
            var isFixed = masthead && masthead.classList.contains('fixed');
            clearHideTimer();
            if (isFixed) {
                showFixedMega();
            } else {
                // dejar al flujo normal (Tailwind hover)
                mega.style.position = '';
                mega.style.left = '';
                mega.style.right = '';
                mega.style.top = '';
                mega.style.zIndex = '';
                mega.style.pointerEvents = '';
                mega.classList.remove('hidden');
            }
        });

        item.addEventListener('mouseleave', function(){
            var isFixed = masthead && masthead.classList.contains('fixed');
            clearHideTimer();
            if (isFixed) {
                hideFixedMega();
            } else {
                // restaurar al estado por Tailwind
                mega.style.position = '';
                mega.style.left = '';
                mega.style.right = '';
                mega.style.top = '';
                mega.style.zIndex = '';
                mega.style.pointerEvents = '';
            }
        });

        // Mantener abierto si el cursor entra al contenedor del mega menú fijo
        mega.addEventListener('mouseenter', function(){
            var isFixed = masthead && masthead.classList.contains('fixed');
            if (!isFixed) return;
            clearHideTimer();
            showFixedMega();
        });
        mega.addEventListener('mouseleave', function(){
            var isFixed = masthead && masthead.classList.contains('fixed');
            if (!isFixed) return;
            hideFixedMega();
        });
    });

});
